import React, { memo, forwardRef } from "react";
const SvgGamma = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.632 24.856a1 1 0 01-1-1v-3.872L10.475 8.287a1 1 0 01.942-1.335h.048a1 1 0 01.948.682l2.099 6.254c.128.384.288.84.48 1.368.192.528.368 1.048.528 1.56.176.496.304.904.384 1.224H16c.912-1.008 1.624-2.064 2.136-3.168a13.45 13.45 0 001.104-3.624c.175-1.025.282-2.124.32-3.296.018-.552.464-1 1.016-1h.088a.972.972 0 01.982 1 23.205 23.205 0 01-.414 3.656 15.399 15.399 0 01-1.512 4.2c-.704 1.344-1.696 2.712-2.976 4.104v3.944a1 1 0 01-1 1h-.112z"
      />
    </svg>
  );
});
SvgGamma.displayName = "SvgGamma";
const MemoForwardRef = memo(SvgGamma);
export default MemoForwardRef;
